import { useSurfacePreference } from "../../../hooks/use-surface-preference.ts"
import {
  CALENDAR_NOTIFICATION_PREFERENCES_KEY,
  DEFAULT_CALENDAR_NOTIFICATION_PREFERENCES,
  normalizeCalendarNotificationPreferences,
  type CalendarNotificationPreferences
} from "./calendar-notification-preferences.ts"

export const useCalendarNotificationPreferences = (): [
  CalendarNotificationPreferences,
  (value: CalendarNotificationPreferences | null) => void
] => {
  const [raw, setRaw] = useSurfacePreference(
    CALENDAR_NOTIFICATION_PREFERENCES_KEY,
    DEFAULT_CALENDAR_NOTIFICATION_PREFERENCES
  )
  return [normalizeCalendarNotificationPreferences(raw), setRaw]
}
